import React from 'react'
import { Link } from 'react-router-dom'
import { useBranding } from '../../context/BrandingContext'

const Footer = () => {
  const branding = useBranding()
  const social = branding?.socialLinks || {}
  const supportEmail = branding?.emailFrom || ''

  return (
    <footer className="hidden md:block bg-gray-100 py-4 mt-8">
        <div className="container mx-auto px-4 grid grid-cols-2 gap-8">
          <div className="text-left">
            <h4 className="font-semibold mb-2">Site Map</h4>
            <ul className="space-y-1 text-sm text-gray-700">
              <li><Link to="/" className="hover:underline">Home</Link></li>
              <li><Link to="/event" className="hover:underline">Submit Event</Link></li>
              <li><Link to="/register-business" className="hover:underline">Register Business</Link></li>
              <li><Link to="/directory" className="hover:underline">Business Directory</Link></li>
              <li><Link to="/legal" className="hover:underline">Legal</Link></li>
            </ul>
          </div>
          <div className="text-right">
            <h4 className="font-semibold mb-2">Connect</h4>
            <ul className="space-y-1 text-sm text-gray-700">
              {social.twitter && (
                <li><a href={social.twitter} target="_blank" rel="noopener noreferrer" className="hover:underline">Twitter</a></li>
              )}
              {social.facebook && (
                <li><a href={social.facebook} target="_blank" rel="noopener noreferrer" className="hover:underline">Facebook</a></li>
              )}
              {social.instagram && (
                <li><a href={social.instagram} target="_blank" rel="noopener noreferrer" className="hover:underline">Instagram</a></li>
              )}
              {supportEmail && (
                <li><a href={`mailto:${supportEmail}`} className="hover:underline">Support Email</a></li>
              )}
            </ul>
          </div>
        </div>
        <div className="mt-4 text-center text-xs text-gray-500 flex flex-wrap justify-center items-center gap-x-2 gap-y-1">
          <span>&copy; {new Date().getFullYear()} {branding?.brandName || 'DeepMaven AI'}. All rights reserved.</span>
          <span>
            Powered by <img src="/deepmaven-branding/brain%20only.svg" alt="DeepMaven AI Logo" className="inline-block w-4 h-4 mx-1" /> <a href="https://deepmavenai.com" target="_blank" rel="noopener noreferrer" className="hover:underline">DeepMaven AI</a>
          </span>
          <span>
            <a href="https://deepmavenai.com/help" target="_blank" rel="noopener noreferrer" className="hover:underline">Website & Web App Acceleration</a>
          </span>
        </div>
    </footer>
  )
}

export default Footer